import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'baseui/snackbar'
import { scheduleCallbackModuleActions } from './ScheduleCallbackSagas'
import { selectScheduledCallbackUpcoming } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import useScheduleCallback from '@/containers/SubscriptionFormPageNew/Components/ScheduleCallback/useScheduleCallback'

const useScheduleCallbackInit = () => {
  const dispatch = useDispatch()
  const { enqueue } = useSnackbar()

  const { zohoId, isAllowedCountry } = useScheduleCallback()

  const upcoming = useSelector(selectScheduledCallbackUpcoming) || {}
  const alreadyLoadedForThisZoho = upcoming.loadedForZohoId === Number(zohoId)

  useEffect(() => {
    if (!zohoId) return
    if (!isAllowedCountry) return
    if (upcoming.isLoading) return
    if (alreadyLoadedForThisZoho) return

    dispatch({
      type: scheduleCallbackModuleActions.LIST_SCHEDULE_CALLBACK,
      zohoContactId: zohoId,
      enqueue,
    })
  }, [zohoId, isAllowedCountry])
}

export default useScheduleCallbackInit
